import React from 'react'
import { Mail } from 'lucide-react'

const HELP_PHONE = '98184-02777'
const HELP_PHONE_TEL = '9818402777'         
const HELP_WHATSAPP = '919818402777'         
const HELP_EMAIL = 'gaurav@factrika.com'
const HELP_EMAIL_SUBJECT = 'Need help with Factrika'
const HELP_CALL_WEEK = 'Mon - Sat'
const HELP_CALL_TIMING = '9:00 AM - 6:00 PM'

const WhatsAppIcon = ({ size = 22, color = '#fff' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill={color}>
    <path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.45 1.32 4.95L2 22l5.29-1.39a9.9 9.9 0 0 0 4.75 1.21h.01c5.46 0 9.9-4.45 9.9-9.91C21.96 6.45 17.5 2 12.04 2zm5.8 14.08c-.24.68-1.4 1.3-1.94 1.38-.5.08-1.12.11-1.8-.11-.42-.13-.96-.31-1.65-.6-2.9-1.25-4.79-4.17-4.94-4.36-.14-.2-1.19-1.58-1.19-3.02 0-1.43.75-2.14 1.02-2.43.27-.29.58-.36.78-.36h.56c.18 0 .42-.07.66.5.24.58.82 2 .89 2.14.07.14.12.31.02.5-.1.2-.15.31-.29.48-.15.17-.31.38-.44.51-.15.15-.3.31-.13.6.17.29.75 1.24 1.62 2.01 1.11.99 2.05 1.3 2.34 1.44.29.15.46.13.63-.08.17-.2.72-.84.92-1.13.19-.29.39-.24.65-.14.27.1 1.68.79 1.97.93.29.15.48.22.55.34.07.13.07.72-.17 1.4z" />
  </svg>
)

const HelpModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null

  const handleCall = () => {
    window.location.href = `tel:${HELP_PHONE_TEL}`
  }

  const handleWhatsApp = () => {
    window.open(`https://wa.me/${HELP_WHATSAPP}`, '_blank')
  }

  const handleMail = () => {
    const subject = encodeURIComponent(HELP_EMAIL_SUBJECT)
    window.location.href = `mailto:${HELP_EMAIL}?subject=${subject}`
  }

  return (
    <>
      {/* backdrop to catch outside clicks */}
      <div
        onClick={onClose}
        style={{ position: 'fixed', inset: 0, zIndex: 999, background: 'transparent' }}
      />

      <div
        style={{
          position: 'absolute',
          top: '100%',
          right: 0,
          marginTop: 8,
          zIndex: 1000,
        }}
      >
        <div
          style={{
            backgroundColor: '#E2E1FD',
            borderRadius: 12,
            padding: 16,
            width: 240,
            boxShadow: '0 3px 4.5px rgba(0,0,0,0.3)',
            border: '1px solid #9F9F9F',
          }}
        >
          <p style={{ fontSize: 20, fontWeight: 'bold', marginBottom: 16, color: '#333' }}>
            Need Help?
          </p>

          <div style={{ marginBottom: 2 }}>
            <p style={{ fontSize: 14, color: '#666', marginBottom: 4 }}>Call Us</p>
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: 4 }}>
              <svg width={16} height={16} viewBox="0 0 24 24" fill="none" stroke="#b82525" strokeWidth={2}>
                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" />
              </svg>
              <span style={{ marginLeft: 8, fontSize: 14, fontWeight: 500, color: '#333' }}>
                {HELP_PHONE}
              </span>
            </div>
          </div>

          <p style={{ fontSize: 13, color: '#008676', margin: '4px 0 10px 4px' }}>
            {HELP_CALL_WEEK},<br />
            {HELP_CALL_TIMING}
          </p>

          <div style={{ marginBottom: 2 }}>
            <p style={{ fontSize: 14, color: '#666', marginBottom: 4, marginTop: 12 }}>Mail Us</p>
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: 4 }}>
              <svg width={16} height={16} viewBox="0 0 24 24" fill="none" stroke="#555" strokeWidth={2}>
                <path d="M4 4h16v16H4z" opacity="0" />
                <path d="M22 6L12 13 2 6" />
                <path d="M2 6h20v12H2z" />
              </svg>
              <span style={{ marginLeft: 8, fontSize: 14, fontWeight: 500, color: '#333' }}>
                {HELP_EMAIL}
              </span>
            </div>
          </div>

          <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 10 }}>
            <button
              onClick={handleCall}
              style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '30%', background: 'none', border: 'none', cursor: 'pointer' }}
            >
              <div style={{ width: 44, height: 44, borderRadius: 22, backgroundColor: '#007AFF', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 4 }}>
                <svg width={22} height={22} viewBox="0 0 24 24" fill="white">
                  <path d="M6.62 10.79a15.05 15.05 0 0 0 6.59 6.59l2.2-2.2a1 1 0 0 1 1.01-.24c1.12.37 2.33.57 3.58.57a1 1 0 0 1 1 1V20a1 1 0 0 1-1 1C10.61 21 3 13.39 3 4a1 1 0 0 1 1-1h3.5a1 1 0 0 1 1 1c0 1.25.2 2.46.57 3.58a1 1 0 0 1-.25 1.01l-2.2 2.2z" />
                </svg>
              </div>
              <span style={{ fontSize: 12, color: '#555' }}>Call</span>
            </button>

            <button
              onClick={handleWhatsApp}
              style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '30%', background: 'none', border: 'none', cursor: 'pointer' }}
            >
              <div style={{ width: 44, height: 44, borderRadius: 22, backgroundColor: '#25D366', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 4 }}>
                <WhatsAppIcon />
              </div>
              <span style={{ fontSize: 12, color: '#555' }}>WhatsApp</span>
            </button>

            <button
              onClick={handleMail}
              style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '30%', background: 'none', border: 'none', cursor: 'pointer' }}
            >
              <div style={{ width: 44, height: 44, borderRadius: 22, backgroundColor: '#FF9500', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 4 }}>
                <Mail size={22} color="#fff" />
              </div>
              <span style={{ fontSize: 12, color: '#555' }}>Mail</span>
            </button>
          </div>
        </div>
      </div>
    </>
  )
}

export default HelpModal